import React from 'react';
import PDFViewer from './PDFViewer';

const ScheduleView = ({ onClose }) => {
    return (
        <PDFViewer
            pdfUrl="/stem_calender.pdf"
            onClose={onClose}
            title="School Schedule 2024-2025"
        />
    );
};
//frontend\frontend\public\stem_calender.pdf
export default ScheduleView;